import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { filter, includes } from 'lodash';
import { branch } from 'baobab-react/higher-order';
import Header from '../../common/Header';
import NavBar from './NavBar';
import Video from './Video';
import SupportNav from '../SupportNav';
import Breadcrumb from '../../common/Breadcrumb';
import BreadcrumbItem from '../../common/BreadcrumbItem';
import { search } from 'superagent';

class Videos extends Component {
	constructor(props) {
		super(props);
		this.state = {
			search: ''
		};
	}

	filterVideos() {

		const videos = this.props.videos.videos;
		let locationFiltered = videos;
		let searchFiltered = videos;

		if (this.props.params.id) {
			locationFiltered = filter(videos, video => {
				return includes(video.category.toLowerCase(), this.props.params.id.toLowerCase());
			});

			if (this.state.search) {
				searchFiltered = filter(locationFiltered, video => {
					let tagStr = video.tag.join(' ').toLowerCase();
					return (
						includes(video.title.toLowerCase(), this.state.search.toLowerCase()) ||
						includes(tagStr, this.state.search.toLowerCase()) ||
						includes(video.category.toLowerCase(), this.state.search.toLowerCase())
					);
				});
				return searchFiltered;
			} else {

				return locationFiltered;
			}

		} else {

			if (this.state.search) {
				searchFiltered = filter(videos, video => {
					let tagStr = video.tag.join(' ').toLowerCase();
					return (
						includes(video.title.toLowerCase(), this.state.search.toLowerCase()) ||
						includes(tagStr, this.state.search.toLowerCase()) ||
						includes(video.category.toLowerCase(), this.state.search.toLowerCase())
					);
				});

				return searchFiltered;
			} else {
				return locationFiltered;
			}
		}
	}

	updateSearch(search) {
		this.setState({ search });
	}

	render() {

		const id = this.props.params.id ? this.props.params.id : null;
		let category = null;
		if (id != null) {
			category = id.charAt(0).toUpperCase() + id.slice(1);
		}
		const { search } = this.state;
		const title = this.props.videos.title;
		const description = this.props.videos.description;

		const videoObjects = this.filterVideos().map((video, index) => (
			<Video
				video={video}
				key={index}
			/>
		));

		return (
			<div className="video-library">
				<Helmet>
					<title>{category ? `Videos: ${category}` : 'Video Library'} &#124; SentrySafe</title>
					<meta name="description" content="Use these videos to guide you through your safe setup, troubleshooting, and other support needs. View videos." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Support" path="/support" />
					<BreadcrumbItem label="Videos" />
				</Breadcrumb>

				<SupportNav />

				<Header
					title={title}
					description={description}
				/>

				<NavBar onChange={text => this.updateSearch(text)} />

				<section className="section section-videos">
					<div className="section-content">
						<p className="video-count">
							{videoObjects.length}
							{videoObjects.length === 1 ? ' video' : ' videos'} returned
							{search.length ? ` for “${search}”` : ''}
						</p>
						<ul>
							{videoObjects}
						</ul>
					</div>
				</section>
			</div>
		);
	}
}

export default branch({
	videos: ['videos']
}, Videos);


// WEBPACK FOOTER //
// ./src/pages/support/videos/Index.js